import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/__auth/admin/appearance')({
    component: AdminAppearanceComponent,
    staticData: {
        title: "routes.appearance",
    },
});

function AdminAppearanceComponent() {
    return (
        <div>
            <h1>Aparência</h1>
            <p>Em breve: Configurações de tema e aparência.</p>
        </div>
    );
}
